import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { DeleteOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { appColors } from "../../../constants/theme";

const DeleteNoteDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,

        }
      }}
    >
      <DialogTitle sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        color: appColors.errorDark,
        fontWeight: 600,
        fontSize: '1.25rem',
        pb: 2,
        pt: 3,
        px: 3
      }}>
        <DeleteOutlined sx={{ fontSize: '1.5rem' }} />
        {title || t("delete_note")}
      </DialogTitle>
      <DialogContent sx={{ px: 3, pb: 2 }}>
        <DialogContentText component="div" sx={{ m: 0 }}>
          <Typography sx={{
            color: appColors.gray900,
            fontSize: '1rem',
            mb: 1.5,
            lineHeight: 1.6,
            fontWeight: 400
          }}>
            {message || t("are_you_sure_delete_note")}
          </Typography>
          <Typography sx={{
            color: appColors.gray500,
            fontSize: '0.875rem',
            lineHeight: 1.5
          }}>
            {t("action_cannot_be_undone")}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 2, gap: 1.5 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: appColors.gray200,
            color: appColors.gray500,
            textTransform: 'none',
            fontWeight: 500,
            px: 2.5,
            py: 0.75,
            '&:hover': {
              borderColor: appColors.gray500,
              backgroundColor: appColors.gray50
            }
          }}
        >
          {cancelButtonText || t("cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          startIcon={<DeleteOutlined />}
          sx={{
            backgroundColor: appColors.errorDark,
            textTransform: 'none',
            fontWeight: 500,
            px: 2.5,
            py: 0.75,
            '&:hover': {
              backgroundColor: appColors.errorDark
            }
          }}
        >
          {confirmButtonText || t("delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteNoteDialog;
